module.exports = __webpack_public_path__ + "static/media/red.b82ae6b1.svg";